import { render, staticRenderFns } from "./CreatePlanStepFour.vue?vue&type=template&id=aefec402&scoped=true"
import script from "./CreatePlanStepFour.vue?vue&type=script&lang=js"
export * from "./CreatePlanStepFour.vue?vue&type=script&lang=js"
import style0 from "./CreatePlanStepFour.vue?vue&type=style&index=0&id=aefec402&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefec402",
  null
  
)

export default component.exports